import { ReactSortable } from 'react-sortablejs';
import { PlusOutlined } from '@ant-design/icons';
import './index.scss';
import { MetricItem } from './metric_item';
import { useActionHandle } from '../useActionHandle';
import React, { useMemo } from 'react';
import { Button } from 'tea-component';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { FilterBasicTime } from '../filters/FilterBasicTime';
import { TIME } from '../filter_basic_condition';
import {deepClone, useDblIntl} from '@/pages/datalab/utils/utils';
import { getFirstColumn, getFlatOptions } from '../../utils';
import SvgIcon from '@/pages/home/components/SvgIcon';

export function MetricEdit(props: {
  columns: IColumnInfo[];
  filterBasic: any[];
  allMetrics: any[];
  optionMetrics: any[];
  dispatchFun: Function;
  allFilters: any[];
  optionFilters: any[];
}) {
  const { columns, filterBasic, allMetrics, optionMetrics, dispatchFun, allFilters, optionFilters } = props;
  const notifyFun = (columnMetrics: IColumnInfo[]) => {
    dispatchFun({
      payload: { columnMetrics },
    });
  };
  const { dblFormatMessage: explorationFormatMessage} = useDblIntl("exploration");
  const handle = useActionHandle(columns, notifyFun);
  const { addItem, setItems } = handle;
  const selectedItems = useMemo(() => columns.map((item) => item.column_name), [JSON.stringify(columns)]);

  return (
    <>
      <FilterBasicTime
        column={filterBasic[TIME]}
        onChange={(columnInfo) => {
          filterBasic[TIME] = columnInfo;
          dispatchFun({ payload: { filterBasic: [...filterBasic] } });
        }}
      />
      <ReactSortable
        list={columns}
        setList={(list: IColumnInfo[]) => {
          setItems(list);
        }}
        handle=".item-drag"
      >
        {(columns || []).map((column, index) => (
          <MetricItem
            key={`${column.table_id}.${column.column_name}`}
            column={column}
            index={index + 1}
            optionMetrics={optionMetrics}
            handle={handle}
            selectedItems={selectedItems}
            onSelectItem={(newItemName: string) => {
              const newColumn = allMetrics.find((item: IColumnInfo) => item.column_name === newItemName);
              if (!newColumn || newColumn.column_name === column.column_name) {
                return;
              }
              const list = [
                ...columns.slice(0, index),
                { ...deepClone(newColumn) },
                ...columns.slice(index + 1, columns.length),
              ];
              setItems(list);
            }}
            allFilters={allFilters}
            optionFilters={optionFilters}
          />
        ))}
      </ReactSortable>
      <span
        className="add-box"
        onClick={() => {
          const flatOptions = getFlatOptions(optionMetrics);
          const newColumn = getFirstColumn(allMetrics, columns, flatOptions);
          if (!newColumn) {
            return;
          }
          addItem(newColumn);
        }}
      >
        <SvgIcon type="add-bg-icon" className="add-box-icon" />
        <span className="add-box-text">{explorationFormatMessage("add_metric")}</span>
      </span>
    </>
  );
}
